import { Box, styled } from '../../base';

export const PageContainer = styled(Box)(({ theme }) => ({
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f5f5f5',
    padding: theme.spacing(3),
}));

export const ContentWrapper = styled(Box)(({ theme }) => ({
    maxWidth: '900px',
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(2),
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
        maxWidth: '100%',
    },
}));

export const LogoSection = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(4, 3, 3, 3),
}));

export const CompanyLogo = styled('img')(() => ({
    maxHeight: '80px',
    maxWidth: '200px',
    objectFit: 'contain',
}));

export const HeaderSection = styled(Box)(({ theme }) => ({
    textAlign: 'center',
    padding: theme.spacing(2, 4, 3, 4),
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2, 2, 3, 2),
    },
}));

export const PurpleSection = styled(Box)(({ theme }) => ({
    backgroundColor: '#7C3AED',
    padding: theme.spacing(4),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(3),
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        gap: theme.spacing(2),
    },
}));

export const SelectWrapper = styled(Box)(() => ({
    minWidth: '280px',
    flex: 1,
    maxWidth: '400px',
}));

export const InfoSection = styled(Box)(({ theme }) => ({
    padding: theme.spacing(3, 4),
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
    },
}));

export const FooterSection = styled(Box)(({ theme }) => ({
    textAlign: 'center',
    padding: theme.spacing(3, 4, 4, 4),
    [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
    },
}));

export const ErrorContainer = styled(Box)(({ theme }) => ({
    maxWidth: '600px',
    width: '100%',
    textAlign: 'center',
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(4),
    boxShadow: theme.shadows[3],
}));

export const LoadingContainer = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
}));

export const PargodaBranding = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
}));
